import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Youtube } from 'lucide-react';
import './Footer.css';

import logoWhite from '../assets/logo-white.png';

const Footer = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const companyPhone = process.env.REACT_APP_COMPANY_PHONE;
  const companyEmail = process.env.REACT_APP_COMPANY_EMAIL;
  const companyAddress = process.env.REACT_APP_COMPANY_ADDRESS;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-logo">
				
              <div className="footer-logo-icon">
				<img
                src={logoWhite}
                alt={companyName}				
              />			  
			  </div>
			  
              {/*<span className="footer-logo-text">{companyName}</span>*/}
            </div>
            <p className="footer-description">
              Leading the future of energy exploration and refining with sustainable practices and operational excellence.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
              <a href="#" className="social-link" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
			  <li><Link to="/products">Our Products</Link></li>
              <li><Link to="/services">Services</Link></li>
			  {/* <li><Link to="/operations">Operations</Link></li> */}
              <li><Link to="/projects">Projects</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Resources</h4>
            <ul className="footer-links">
              <li><Link to="/sustainability">Sustainability</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#">News & Media</a></li>
              <li><a href="#">Investor Relations</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <MapPin size={18} />
                <span>{companyAddress}</span>
              </li>
              <li>
                <Phone size={18} />
                <a href={`tel:${companyPhone}`}>{companyPhone}</a>
              </li>
              <li>
                <Mail size={18} />
                <a href={`mailto:${companyEmail}`}>{companyEmail}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} {companyName}. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#">Privacy Policy</a>
            <span>|</span>
            <a href="#">Terms of Service</a>
            <span>|</span>
            <a href="#">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;